import React from 'react';

const CIRCLES = [
  { r: 28, size: 6, color: '#3a7bc8', dur: '2s', delay: '0s' },
  { r: 28, size: 6, color: '#6c5ce7', dur: '2s', delay: '-0.66s' },
  { r: 28, size: 6, color: '#00b894', dur: '2s', delay: '-1.33s' },
  { r: 44, size: 5, color: '#74b9ff', dur: '2.8s', delay: '0s' },
  { r: 44, size: 5, color: '#a29bfe', dur: '2.8s', delay: '-0.93s' },
  { r: 44, size: 5, color: '#55efc4', dur: '2.8s', delay: '-1.86s' },
];

export default function GravityLogo({ size = 100, circle }) {
  const scale = size / 100;
  const w = circle ? size : size;
  const h = size * 0.95;
  const ovalW = size * 0.82;
  const ovalH = circle ? size * 0.82 : size * 0.88;

  return (
    <div className="glogo" style={{ width: w, height: h, flexShrink: 0 }}>
      <div className="glogo-oval" style={{
        width: ovalW, height: ovalH,
        borderRadius: '50%',
      }} />
      <span className="glogo-letter" style={{ fontSize: size * 0.42 }}>G</span>
      {CIRCLES.map((c, i) => (
        <span key={i} className="glogo-dot" style={{
          '--orbit-r': `${c.r * scale}px`,
          width: c.size * scale,
          height: c.size * scale,
          marginLeft: -(c.size * scale) / 2,
          marginTop: -(c.size * scale) / 2,
          background: c.color,
          animationDuration: c.dur,
          animationDelay: c.delay,
        }} />
      ))}
    </div>
  );
}
